export default function capitalize(value) {
  if (value) {
    const text = value.toString();
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  return value;
}
